import { render, staticRenderFns } from "./BaseSubmit.vue?vue&type=template&id=61013bd1&"
import script from "./BaseSubmit.vue?vue&type=script&lang=js&"
export * from "./BaseSubmit.vue?vue&type=script&lang=js&"
import style0 from "./BaseSubmit.vue?vue&type=style&index=0&id=61013bd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports